import { render, staticRenderFns } from "./DamageLossesCreate.vue?vue&type=template&id=51f2c312"
import script from "../../controllers/damage-losses/damage-losses-create?vue&type=script&lang=js&external"
export * from "../../controllers/damage-losses/damage-losses-create?vue&type=script&lang=js&external"
import style0 from "./DamageLossesCreate.vue?vue&type=style&index=0&id=51f2c312&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports